<p-dialog #addUserDialog [contentStyle]="{'max-height':'85vh'}" [focusOnShow]="false" width="800" minHeight="600"
  [closable]="false" [blockScroll]="true" [modal]="true" [draggable]="false" [baseZIndex]="500"
  header="Transfer a Short Code" [(visible)]="display" (onHide)="cancel()">
  <div class="w-450px">
    <iui-messages #message  class="ms-auto me-auto"></iui-messages>
  </div>

  <form #transferForm="ngForm">
    <div class="mb-2 ms-3 me-5">
      <div class="row mb-3">
        <div class="col-12">
          Enter the Account ID of the organization to which you want to transfer this short code.
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 ">
          <span class="fw-bold">Transfer Short Code: {{scId}}</span>
        </div>
      </div>


      <div class="row">
        <div class="col-4 ">
          <label for="toAccountId" class="required">To Account ID: </label>

          <p-inputNumber appIn #toAccountId="ngModel" name="toAccountId" [required]="true" id="toAccountId"
            [maxlength]="10" [(ngModel)]="toAccountIdValue" placeholder="Account ID" mode="decimal"
            [useGrouping]="false"></p-inputNumber>

          <app-error-msg [field]="toAccountId" fieldLabel="To Account ID"></app-error-msg>

        </div>

      </div>

      <div class="mt-4">
        <div class="ms-0 ">


          <label for='termAgreement' class="required">
          <p-checkbox name="termAgreement" id="termAgreement" [(ngModel)]="transferAgreement" [required]="true"
            [binary]="true" [binary]="true" #termAgreementCheckbox="ngModel" label="Terms"> </p-checkbox>
            </label>
        </div>

        <div class="error-msg" *ngIf="termAgreementCheckbox.errors && termAgreementCheckbox.touched">
          <span class="failed">
            Please select the transfer acceptance checkbox.
          </span>
        </div>


        <div class="row mt-1 ms-0">
          <div class="row ms-0 term-align">
            As a representative of the organization releasing the short code, I hereby request the transfer of
            short code {{scId}} from my account to the Account ID specified above. I understand that iconectiv, as the
            registry service provider for short codes, will effectuate the transfer as promptly as commercially
            possible after receipt of authorization from both the Releasing Organization and the Receiving Organization. I
            understand that by agreeing to this short code transfer, I am relinquishing all rights to this code and its
            associated campaign(s) and content. I understand that if this code was pre-paid, neither CTIA nor
            iconectiv is responsible for furnishing any reimbursement for any remaining portion of the lease term.
            In this case, the term of the lease and the expiration date remain unchanged. I further understand
            that if this code is enrolled in monthly billing, payment of the ongoing monthly payments will no
            longer be my account's responsibility, and will instead become the responsibility of the receiving
            account. In this case, the term of the lease is reset (to 12 months if transferring from monthly billing to
            monthly billing; or to 3 months if transferring from monthly billing to pre-paid) and the expiration
            date is reset as appropriate.
          </div>
        </div>
      </div>
    </div>

  </form>
  <p-footer>
    <div class="d-flex justify-content-end me-2">
      <button i18n id="scaccept" class="btn btn-primary me-2" type="button"
        (click)="transferShortCode(transferForm)">OK</button>
      <button i18n id="screject" class="btn btn-secondary" type="button" (click)="closeDialog()">Cancel</button>
    </div>
  </p-footer>
</p-dialog>